// export const TOKEN_ENDPOINT = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'http://localhost:3000/' : process.env.REACT_APP_PUBLIC_URL
export const TOKEN_ENDPOINT = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'http://localhost:3000' : `${window.location.origin}`
